<template>
  <v-sheet
    height="100%"
    class="overflow-scroll menu"
    style="position: relative; margin-top: 0px; border-radius: 0"
  >
    <v-app v-if="isWaiting">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <v-card flat class="mx-auto px-10" max-width="470" height="300px">
          <v-card-title> Por favor espere </v-card-title>
          <v-card-subtitle>No hay ninguna grabación activada</v-card-subtitle>
          <v-chip
            :color="users.technician != null ? '#749948' : 'disabled'"
            class="py-4 px-5 mb-4"
            text-color="white"
            style="font-size: 14px; border-radius: 22px"
          >
            <v-icon small left>
              {{
                users.technician != null
                  ? "mdi-eye-outline "
                  : "mdi-eye-off-outline"
              }}
            </v-icon>
            Técnico
          </v-chip>
          <v-progress-linear
            color="admiraGreen"
            indeterminate
            rounded
            height="7"
          ></v-progress-linear>
        </v-card>
      </div>
    </v-app>
    <Header
      v-else
      icon="mdi-record-circle-outline"
      subtitle="Grabación"
      :title="`${actualSpot.spotCode} - ${actualSpot.name}`"
      :title-size="26"
      :show-back="false"
      truncate
    />
    <v-divider style="border-width: 1px" class="background" />
    <div class="fill-height ma-0 d-flex" :class="classObjectHeight">
      <v-row cols="12" style="height: 100%">
        <v-col cols="12" style="padding-top: 22px">
          <v-row class="mx-auto" style="max-width: 800px">
            <v-col style="position: relative">
              <div
                v-show="role === 'slave_plus' || role === 'slave_plus_remote'"
              >
                <vue-editor
                  id="reader-slave-plus"
                  ref="quillEditorPlus"
                  :value="textSpotSpeaker"
                  :editorToolbar="customToolbar"
                  class="sliderSize"
                  @text-change="changingTextSpotSlave"
                />
              </div>
              <v-overlay v-if="roleChangingTxt && roleChangingTxt !== role" absolute>
                <v-row
                  class="fill-height"
                  align-content="center"
                  justify="center"
                >
                  <v-col class="text-subtitle-1 text-center" cols="12">
                    {{ roleChangingTxt === 'technician' ? 'El Técnico está escribiendo' : 'El Creativo está escribiendo' }}
                  </v-col>
                  <v-col cols="6">
                    <v-progress-linear
                      color="admiraGreen"
                      indeterminate
                      buffer-value="0"
                      stream
                      reverse
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </v-overlay>
              <template v-if="role === 'slave'">
                <vue-editor
                  id="reader-slave"
                  class="sliderSize"
                  :style="cssVars"
                  :value="textSpotSpeaker"
                  :editorOptions="editorOptions"
                  disabled
                />
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col class="pa-8 background d-flex flex-column" style="height: calc(100vh - 160px); max-width: 320px">
        <div>
          <v-row class="mb-0">
            <p style="font-size:16px;" class="text-left text--text">{{ companyName }}</p>
          </v-row>
          <v-row class="mb-0">
            <p style="font-size:16px;" class="text-left text--text">{{ slaveActivityDescription }}</p>
          </v-row>
          <v-row class="negative-m">
            <p class="text--text" style="font-size:16px;">Medio</p>
          </v-row>
          <v-row class="mb-6">
            <v-chip outlined color="grey" class="ma-1 bg-white">
              <span class="gray-chips text--text">{{ slaveMediaCheck }}</span>
            </v-chip>
          </v-row>
          <v-row class="negative-m">
            <p class="text--text" style="font-size:16px;">Intervienen</p>
          </v-row>
          <v-row class="mb-0" style="gap: 8px">
            <v-chip v-for="provider in slaveProviders" :key="provider._id" outlined pill class="text--text">
              {{ provider && provider.providerId ? provider.providerId.alias : '' }}
            </v-chip>
          </v-row>
        </div>
        <v-spacer></v-spacer> 
        <div>
          <v-chip class="" color="primary">
            {{ dataSaveSpot?.currentIndex }} de {{ dataSaveSpot?.totalSpots }} cuñas
          </v-chip>
        </div>
      </v-col>
    </div>
    <v-overlay color="background" opacity="1" absolute :value="loadingAudio">
      <h3 class="text--primary">Por favor espere</h3>
      <p class="text--primary">Cargando audio</p>
      <v-chip
        :color="users.technician != null ? '#749948' : 'disabled'"
        class="py-4 px-5 mb-4"
        text-color="white"
        style="font-size: 14px; border-radius: 22px"
      >
        <v-icon small left>
          {{
            users.technician != null ? "mdi-eye-outline " : "mdi-eye-off-outline"
          }}
        </v-icon>
        Técnico
      </v-chip>
      <v-progress-linear
        color="admiraGreen"
        indeterminate
        rounded
        height="7"
      ></v-progress-linear>
    </v-overlay>
    <v-overlay :value="overlay">
      <v-card
        flat
        class="mx-auto px-10 my-auto d-flex flex-column justify-center"
        max-width="470"
        height="150px"
      >
        <v-card-title> {{ dialogMsg }}</v-card-title>
        <v-progress-linear
          color="admiraGreen"
          indeterminate
          rounded
          height="7"
        ></v-progress-linear>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Header: defineAsyncComponent(() => import("../components/Header.vue")),
  },
  data() {
    return {
      customToolbar: [["link", "underline", "italic", "bold"]],
      editorOptions: { modules: { toolbar: false } },
      loadingAudio: false,
      showLoader: true,
      overlay: false,
      dialogMsg: "",
    };
  },
  computed: {
    ...mapState([
      "actualSpot",
      "connectedToTechnician",
      "role",
      "textSpotSpeaker",
      "roleChangingTxt",
      "studio",
      "allowedCitations",
      "sliderSocket",
      "dialogSocketConnection",
      "accessRemote",
      "users",
      "dataSaveSpot",
      "closeShowRecording",
    ]),
    
    classObjectHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "height-scroll-xs-sm";
        case "sm":
          return "height-scroll-xs-sm";
        case "md":
          return "height-scroll";
        case "lg":
          return "height-scroll";
        case "xl":
          return "height-scroll";
      }
    },
    cssVars() {
      return {
        "--slider": `${this.sliderSocket}px`,
      };
    },
    slaveActivityDescription() {
      const activity = this.dataSaveSpot && this.dataSaveSpot.actualActivity
      return activity && activity.activityId ? activity.activityId.description : ''
    },
    companyName() {
      const activity = this.dataSaveSpot && this.dataSaveSpot.actualActivity
      return activity && activity.companyId ? activity.companyId.name : ''
    },
    slaveMediaCheck() {
      return this.dataSaveSpot && this.dataSaveSpot.mediaType ? this.dataSaveSpot.mediaType : ''
    },
    slaveProviders() {
      return this.dataSaveSpot && this.dataSaveSpot.arrProviders ? this.dataSaveSpot.arrProviders.providers : []
    },
    falseSpot() {
      return (
        this.actualSpot.mediaType === "MEGAFONIA" &&
        this.actualSpot.texts.criteria?.id === undefined
      );
    },
    isWaiting() {
      if (!this.allowedCitations || this.actualSpot == null) return true;
      return this.falseSpot || this.showLoader || !this.closeShowRecording;
    },
  },
  methods: {
    ...mapActions(["sendTextSpot"]),
    changingTextSpotSlave() {
      if (this.roleChangingTxt !== "technician" && this.role !== "technician") {
        if (this.firstEntryEditorC) {
          this.$nextTick(() => {
            if (this.$refs.quillEditorPlus.quill.root.innerHTML) {
              this.debounceTextSpot(
                this.$refs.quillEditorPlus.quill.root.innerHTML
              );
            }
          });
        } else {
          this.firstEntryEditorC = true;
          this.showLoader = false;
        }
      }
    },
    async saveText() {
      this.$globalData.socket.emit("updateSpotList", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: true,
        });
    },
    debounceTextSpot(text) {
      if(this.role === "slave") return
      this.$globalData.socket.emit("textChangedBy", {
        toNamespace: "ECI_ESTUDIO",
        toRoom: `estudio${this.studio}`,
        data: this.role,
      });
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$globalData.socket.emit("textRecording", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: text,
        });
        this.$globalData.socket.emit("textChangedBy", {
          toNamespace: "ECI_ESTUDIO",
          toRoom: `estudio${this.studio}`,
          data: "",
        });
      }, 650);
    },
  },
  watch: {
    roleChangingTxt(newValue, oldValue) {
      if (
        newValue !== oldValue &&
        this.roleChangingTxt &&
        this.roleChangingTxt !== this.role
      ) {
        if (this.role === "slave_plus" || this.role === "slave_plus_remote")
          this.$refs.quillEditorPlus.quill.root.blur();
        else if (this.role === "technician")
          this.$refs.quillEditor.quill.root.blur();
      }
    },
    allowedCitations() {
      if (this.allowedCitations == false) {
        if (this.role === "slave_plus")
          this.$refs.quillEditorPlus.quill.root.blur();
        else if (this.role === "technician")
          this.$refs.quillEditor.quill.root.blur();
      }
    },
    actualSpot() {
      this.$refs.quillEditorPlus.quill.root.blur();
      clearTimeout(this.changingSpot);
      this.showLoader = true;
      this.changingSpot = setTimeout(() => {
        this.showLoader = false;
      }, 650);
    },
    accessRemote() {
      if (this.accessRemote == false) {
        this.dialogMsg = "Sesión finalizada. Saliendo...";
        this.overlay = true;
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    },
  },
  mounted() {
    if (process.env.VUE_APP_MODE == "web") {
      if (this.$store.state.logued == false) {
        this.$router.push("/login");
      }
    } else {
      if (this.$store.state.studio == null) {
        this.$router.push("/home-slave");
      }
    }
  },
};
</script>
<style>
#reader-slave.ql-container.ql-snow {
  border: 0 !important;
  border-radius: 25px;
  background: white;
  height: calc(100vh - 215px);
}
#reader-slave-plus.ql-container.ql-snow {
  border: 0 !important;
  background: white;
  height: calc(100vh - 300px);
}
#reader-slave-plus .ql-editor {
  font-size: inherit;
}
#reader-slave .ql-editor {
  font-size: inherit;
}
.floating-btn {
  z-index: 999;
  position: absolute;
  top: 20px;
  right: 20px;
}
.sliderSize .ql-container {
  font-size: var(--slider)
}
</style>
